export default {
  IS_DEV: false,

  contact_email: '',

  github_repository_link: 'http://github.com/',

  github_api_repository_link: 'http://github.com/',
}
